<script lang="ts">
  import type { IconNode } from "lucide";
  // Render a lucide-core IconNode as an inline SVG. We use `lucide` (core IconNode
  // data) rather than @lucide/svelte because @lucide/svelte names its rest binding
  // `props`, which collides with the $props rune and crashes Svelte 5 at runtime.
  // The rest binding here MUST stay named `rest` for the same reason.
  let {
    icon,
    size = 24,
    strokeWidth = 2,
    class: klass = "",
    ...rest
  }: {
    icon: IconNode;
    size?: number | string;
    strokeWidth?: number | string;
    class?: string;
  } & Record<string, unknown> = $props();
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width={strokeWidth}
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
  class={klass}
  {...rest}
>
  {#each icon as [tag, attrs]}
    <svelte:element this={tag} {...attrs} />
  {/each}
</svg>
